<template>

  <div class="page_container">
      <div class="get_yinbi_item_container">
        <div class="get_yinbi_item_left">
            <div class="get_yinbi_item_text_a">评论回馈</div>
            <div class="get_yinbi_item_text_b">留下应用市场评论，获取500硬币奖励</div>
            <div class="get_yinbi_item_text_c" @click="toSubmitPinglunhuikui">投稿获取奖励</div>
        </div>

        <div class="get_yinbi_item_img">
          <img :src="require('@/assets/comment.png')"  />

        </div>

        
        

      </div>


      <div class="get_yingbi_intro">
        <div class="get_yingbi_intro_item">

          
          <div class="get_yingbi_intro_item_main_body">在应用市场给净信背单词留下一个评论反馈，截图提交即可获得500硬币奖励</div>

        </div>



        <div class="get_yingbi_intro_item">

          <div class="get_yingbi_intro_item_title">规则</div>
          <div class="get_yingbi_intro_item_main_body">1. 评论最少15个字</div>
      <div class="get_yingbi_intro_item_main_body">2. 每30天可申领一次，以获取奖励时间为准</div>
      <div class="get_yingbi_intro_item_main_body">3. 发布时间需要提交审核前一周内</div>
      <div class="get_yingbi_intro_item_main_body">4. 申请将在7个工作日内审核并发放奖励</div>
      <div class="get_yingbi_intro_item_main_body">5. 结果在我的硬币页面查看</div>

        </div>



        
        
        
      </div>
    

  </div>

  
 



  
  

  
    
  </template>
  
  <script setup >

  import { useRouter } from 'vue-router';

const router = useRouter();

function toSubmitPinglunhuikui(){
  const url = router.resolve({ name: 'SubmitPinglunhuikui' }).href;
  window.location.href = url;
}



</script>
  
  <style scoped>

  

  .page_container {
    display: flex;
    flex-direction: column;
    align-content: center;
    align-items: center;
    
  }

  .get_yinbi_item_container{
    display: flex;
    flex-direction: row;
    align-content: center;
    align-items: center;
    justify-content: center;
    background: #ededed;
    border-radius: 0.3rem;
    width: 98%;
    
  }

  .get_yinbi_item_left{
    display: flex;
    flex: 3;
    flex-direction: column;
    align-content: center;
    align-items: center;
    justify-content: center;
    margin: 0.1rem 0.2rem;

    
    
  }

  .get_yinbi_item_img{
    display: flex;
    flex: 2;
    
    margin-top: 0.2rem;
    margin-bottom: 0.3rem;
    justify-content: center;
    
  }
  .get_yinbi_item_img img{
    width: 60%;
  }

  .get_yinbi_item_text_a{
    font-size: 0.7rem;
    margin-bottom: 0.1rem;
    
  }

  .get_yinbi_item_text_b{
    font-size: 0.3rem;
    color: #848488;
    
  }

  .get_yinbi_item_text_c{
    font-size: 0.5rem;
    color: white;
    margin-top: 0.3rem;
    padding: 0.1rem 1rem;
    background: #0C84FF;
    border-radius: 0.3rem;
    margin-bottom: 0.1rem;
    margin-top: 0.3rem;
  }

  .get_yingbi_intro{
    display: flex;
    flex-direction: column;
    
    justify-content: left;

    margin-top: 0.5rem;
  }


  .get_yingbi_intro_item{
    display: flex;
    flex-direction: column;

    margin-bottom: 0.5rem;
    
    
    margin-left: 0.3rem;
    
  }

    
    
  .get_yingbi_intro_item_title{
    font-size: 0.4rem;
    
    margin-bottom: 0.1rem;
    color: #000000;
    text-align: left;
    
  }
  .get_yingbi_intro_item_main_body{
    font-size: 0.4rem;
    color:#848488;
    margin-bottom: 0.1rem;
    
    
    text-align: left;
  }



  

  






  </style>